<template>
  <div
    class="HeaderNav"
    :class="{'hide':!show,'other':other}"
    :style="{backgroundColor:isR?'#0276F7':''}"
  >
    <div class="module">
      <div class="logo">
        <router-link tag="div" to="/"><img style="cursor: pointer;" src="../assets/images/header/logo.png" alt=""></router-link>
      </div>
      <div class="nav">
        <div class="content">
          <a :href="element.url"
            v-for="(element,index) in data.content"
            :key="index"
            @mouseenter="navHover(element)"
            @mouseleave="navOut(element)"
            
            :style="{color:isA(element.url)?'#fff':''}">
            {{element.name}}
            <transition name="slide">
              <div class="nextNav" v-if="element.content&&element.show">
                <a :href="element2.url"
                  v-for="(element2,index) in element.content"
                  :key="index"
                  
                  :style="{color:isA(element2.url)?'#0276F7':''}">{{element2.name}}</a>
              </div>
            </transition>
          </a>
        </div>
      </div>
    </div>
    <div class="mobile-module" :style="{backgroundColor:isR?'#0276F7':''}">
      <div class="menu-group">
        <img src="../assets/images/header/group.png" alt="" @click="drawer = true">
      </div>
      <div class="group">
        <div class="logos">
          <router-link tag="div" to="/"><img style="cursor: pointer;" src="../assets/images/header/header.png" alt=""></router-link>
        </div>
      </div>
      
    </div>
    <el-drawer class="drawer-container"
      :visible.sync="drawer"
      :with-header="false"
      :direction="direction"
      :modal="false"
      size="22.5rem">
      <div class="close" @click="closeDrawer">
        ×
      </div>
      <div class="mobile-menu">
        <div class="menus">
          <div v-for="(element,index) in data.content" :key="index" class="ul">
            <div 
            @click="toOther(element)"
            :class="isA(element.url) ? 'active content-name' : 'content-name'"
            >
              {{element.name}}
            </div>
            <div v-for="(element2,index2) in element.content"
            class="li"
            :key="index2">
              <a :href="element2.url"
                :style="{color:isA(element2.url) ? '#0276F7' : ''}"
                >{{element2.name}}</a>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- <div class="router-menu" v-if="drawer">
      <div class="close" @click="closeDrawer">
        ×
      </div>
      <div class="mobile-menu">
        <div class="menus">
          <ul v-for="(element,index) in data.content" :key="index">
            <div 
            @click="toOther(element)"
            :class="isA(element.url) ? 'active' : ''"
            >
              {{element.name}}
            </div>
            <li v-for="(element2,index2) in element.content"
            :key="index2">
              <a :href="element2.url"
                :style="{color:isA(element2.url) ? '#0276F7' : ''}"
                >{{element2.name}}</a>
            </li>
            
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "HeaderNav",
  props: ["data"],
  data() {
    return {
      oldScrollTop: 0,
      show: true,
      other: false,
      drawer: false,
      direction: 'ltr'
    };
  },
  computed: {
    isA: function() {
      return function(url) {
        let currentPath = this.$route.path;
        if (currentPath.endsWith('/')) {
          currentPath = currentPath.slice(0, -1);  // 去掉结尾的 '/'
        }
        if (url == currentPath) {
          return true;
        } else {
          return false;
        }
      };
    },
    isR: function() {
      if ("/" == this.$route.path || "Newsdetails" == this.$route.name) {
        return true;
      }
    }
  },
  mounted: function() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    jump: function(element) {
      if(element.name == "技术方案"){
        window.open("http://www.ztmapinfo.com/blog")
      }else{
        this.$router.push({ path: element.url });
      }
      
    },
    navHover: function(element) {
      element.show = true;
    },
    navOut: function(element) {
      element.show = false;
    },
    scrollToTop: function() {
      let newScrollTop = document.scrollingElement.scrollTop;
      /* 下滑到看不见导航之前 */
      if (newScrollTop <= 70) {
        //this.show = true;
        this.other = false;
        return false;
        /* 看不见导航了 */
      } else {
        this.other = true;
      }
      /* 下滑 */
      if (newScrollTop > this.oldScrollTop) {
        //this.show = false;
        /* 上滑 */
      } else {
        //this.show = true;
      }
      /* 记录新值 */
      this.oldScrollTop = newScrollTop;
    },
    closeDrawer: function() {
      this.drawer = false
    },
    toOther: function(element) {
      if(element.name == "技术方案"){
        window.location.href = "http://www.ztmapinfo.com/blog/index.php";
      }else{
        this.$router.push({ path: element.url });
      }
      this.drawer = false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.slide-enter {
  //显示前的效果
  opacity: 0;
  transition: all 0.2s linear;
}
.slide-enter-to {
  //显示后的效果
  opacity: 1;
  transition: all 0.2s linear;
}

.slide-leave {
  //隐藏前的效果
  opacity: 1;
  transition: all 0.2s linear;
}

.slide-leave-to {
  //隐藏后的效果
  opacity: 0;
  transition: all 0.2s linear;
}
.HeaderNav {
  pointer-events: auto;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  transition: 0.23333333s top cubic-bezier(0.075, 0.82, 0.165, 1),
    0.23333333s background-color cubic-bezier(0.075, 0.82, 0.165, 1);
  &.hide {
    top: -70px;
  }
  &.other {
    background: rgba(0, 0, 0, 0.5) !important;
  }
  > .module {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      // float: left;
      width: 136px;
      display: flex;
      align-items: center;
      height: 70px;
      >div {
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .nav {
      // float: right;
      height: 100%;
      .content {
        height: 100%;
        display: flex;
        > a {
          height: 70px;
          display: inline-block;
          padding: 0 22px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 70px;
          cursor: pointer;
          position: relative;
          &::before {
            content: "";
            position: absolute;
            top: -20px;
            left: 100%;
            width: 0;
            height: 100%;
            border-bottom: 1px solid #fff;
            transition: 0.2s all linear;
            z-index: 999;
          }
          &:hover::before {
            width: 50%;
            left: 25%;
          }
          &:hover ~ div::before {
            left: 25%;
          }
          .nextNav {
            position: absolute;
            white-space: nowrap; // 自动宽度 不受制 relative 父元素
            background: #fff;
            color: #4b4b4b;
            padding: 0 30px;
            line-height: 60px;
            text-align: center;
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
            left: 0px;
            z-index: 999;
            transition: 0.2s opacity linear;
            top: 80px;
            > a{
              white-space: nowrap;
              line-height: 60px;
              display: block;
              text-align: center;
              color:#333;
            }
            > a:hover {
              
              color: @baseColor;
            }
            &::before {
              content: "";
              width: 0;
              height: 0;
              border-right: 10px solid transparent;
              border-left: 10px solid transparent;
              border-bottom: 10px solid #fff;
              position: absolute;
              top: -10px;
              left: 40px;
            }
          }
        }
      }
    }
  }
  > .mobile-module {
    width: 100%;
    height: 5rem;
    display: none;
    line-height: 5rem;
    position: relative;
    .menu-group {
      position: absolute;
      left: 2rem;
      top: 0;
      height: 100%;
      line-height: 5rem;
      img{
        height: 1.6rem;
      }
    }
    .group {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .logos {
        display: flex;
        align-items: center;
        height: 100%;
        img{
          margin-top: 2rem;
          width: 9rem;
          height: 2rem;
        }
      }
    }
  }
  // .router-menu {
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   width: 22.5rem;
  //   // height: 1vh;
  //   // height: 100%;
  //   background-color: white;
  //   overflow-y: scroll;
    
  // }
  .close {
    width: 100%;
    height: 5rem;
    display: flex;
    align-items: center;
    font-size: 2.8rem;
    font-weight: 500;
    box-sizing: border-box;
    padding-left: 1.5rem;
    cursor: pointer;
  }
  .mobile-menu {
    width: 100%;
    display: block;
    .menus {
      font-size: 1.4rem;
      font-family: "Normal";
      font-weight: 350;
      line-height: 2rem;
      letter-spacing: 0rem;
      box-sizing: border-box;
      padding-left: 2rem;
      padding-bottom: 2rem;
      .ul {
        margin-top: 2rem;
        .content-name {
          height: 2rem;
          box-sizing: border-box;
          padding-left: 1.5rem;
          border-left: 0.4rem solid transparent;
          cursor: pointer;
        }
        .content-name:hover {
          border-left: 0.4rem solid #3C80E8;
          color: #3C80E8;

        }
        .active {
          border-left: 0.4rem solid #3C80E8;
          color: #3C80E8;
        }
        .li {
          width: 100%;
          list-style: none;
          box-sizing: border-box;
          padding-left: 4rem;
          margin-top: 1rem;
          font-size: 1.2rem;
          a {
            color: #333;
          }
          a:hover {
            color: #3C80E8;
          }
          .select {
            color: #3C80E8;
          }
        }
      }
    }
  }
  
}

@media (max-width: 1024px) {
  .module {
    display: none !important;
  }
  .mobile-module { 
    display: block !important;
  }
}
@media (min-width: 1025px) {
  .drawer-container {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue